import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import cn from "clsx";
import pluralize from "pluralize";
import React from "react";
import { useWatch } from "react-hook-form";
import { getCurrency } from "../../../../hooks";
import { useTripBuilderQuote } from "../context/TripBuilderQuoteStepContext";
import styles from "./TripBuilderQuoteStep.module.scss";

export const QuoteTotalSummary: React.FC = () => {
    const { formatCurrency } = getCurrency();
    const { draftQuote } = useTripBuilderQuote();
    const { productPage } = useI18n("productPage");
    const nbTravelers = useWatch({ name: "nbTravelers" });
    const grandTotal = draftQuote?.order.grandTotal.value || 0;
    const minDeposit = draftQuote?.order.checkoutOptions.length
        ? Math.min(
              ...draftQuote.order.checkoutOptions.map(
                  (option) => option.amount.value,
              ),
          )
        : null;
    const amountDueToday =
        typeof minDeposit === "number" ? formatCurrency(minDeposit) : null;

    return (
        <>
            <dl
                className={cn(
                    styles["value-group"],
                    styles["value-group--padded"],
                )}
            >
                <Text.Heading tag="dt" order="5">
                    {productPage.tripBuilder.quote.summary.grandTotalLabel.l({
                        nbTravelers,
                    })}{" "}
                    {pluralize(
                        productPage.tripBuilder.quote.summary.grandTotalUnit.l(),
                        nbTravelers,
                    )}
                </Text.Heading>
                <Text.Heading tag="dd" order="5">
                    {formatCurrency(grandTotal)}
                </Text.Heading>
                {nbTravelers > 1 && (
                    <>
                        <Text.Heading tag="dt" order="5">
                            {productPage.tripBuilder.quote.summary.totalPerPersonLabel.l()}
                        </Text.Heading>
                        <Text.Heading tag="dd" order="5">
                            {formatCurrency(
                                draftQuote?.order.averageTotalPerTrip.value ||
                                    0,
                            )}
                        </Text.Heading>
                    </>
                )}
            </dl>
            <dl
                className={cn(
                    styles["value-group"],
                    styles["value-group--padded"],
                )}
                style={{
                    backgroundColor: "var(--s-color-brand-primary-quiet)",
                }}
            >
                <Text.Heading tag="dt" order="5">
                    {productPage.tripBuilder.quote.summary.dueTodayLabel.l()}
                </Text.Heading>
                <Text.Heading tag="dd" order="5">
                    {amountDueToday}
                </Text.Heading>
            </dl>
        </>
    );
};
